module.exports = __webpack_public_path__ + "media/images/img_support02-82a5bd1e73e9d091eeb122f6c1ea93d6.jpg";